import { Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { ValidLoginService } from "./auth/valid-login.service";
import { AuthService } from "./services/login/auth.service";
import { Router } from '@angular/router';

@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.css",
})
export class AppComponent {
  private validLoginService = inject(ValidLoginService);
  private authService = inject(AuthService);
  private router = inject(Router);
  
  ngOnInit(): void {
    this.authService.getUsuarioA().subscribe((litening) => {
      console.log("litening", litening);
    });

    // OBTIENE LA URL DESPUES DE #
    const hash = window.location.hash;
    if (hash.startsWith('#/')) { //if (hash.startsWith('#/entrada/')) {
      debugger;
      
      // QUITAR EL "#" LIMPIAMOS URL
      const cleanPath = this.obtenerUrlNueva(hash);

      // REDIRECCIONAR
      this.router.navigateByUrl(cleanPath);
    }
  }

  obtenerUrlNueva(hash: string) {
    var corporativo = hash.toUpperCase().includes('ENTRADA/CORPORATIVO');
    if(corporativo) {
        return hash.replace('#/entrada/corporativo','/entrada');
    }

    var mrb = hash.toUpperCase().includes('MRB');
    if(mrb) {
        return '/acuerdos-mrb-listado';
    }

    var despacho = hash.toUpperCase().includes('DESPACHO');
    if(despacho) {
        return '/despacho/listado';
    }

    return hash.substring(1);
  }

}
